module.exports = __webpack_public_path__ + "static/media/testfile_pl.2bb3517f.zip";